export const useGoogleAuthStore = defineStore("google-auth", () => {
    const googleBaseUrl = useRuntimeConfig().public.googleAuthBaseUrl;
    const oneTapBaseUrl = useRuntimeConfig().public.googleOneTapBaseurl;

    const verifyUserWithToken = async (payload: IGoogleLoginPayload) => {
        return await useFetch(googleBaseUrl, {
            method: "POST",
            body: payload,
        });
    };

    // ! types and interfaces
    const googleOneTapAuth = async (payload: any) => {
        return await useFetch(oneTapBaseUrl, {
            method: "POST",
            body: payload,
        });
    };

    return { verifyUserWithToken, googleOneTapAuth };
});
